import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luTemplateDocument = {
  state: {
    luTemplateDocuments: [],
    selectedLuTemplateDocument: {},
    selectedLuTemplateDocumentOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luTemplateDocuments(state) {
      return state.luTemplateDocuments
    },
    selectedLuTemplateDocument(state) {
      return state.selectedLuTemplateDocument
    },
    selectedLuTemplateDocumentOriginal(state) {
      return state.selectedLuTemplateDocumentOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luTemplateDocuments(state, payload) {
      state.luTemplateDocuments = payload
    },
    selectedLuTemplateDocument(state, payload) {
      state.selectedLuTemplateDocument = JSON.parse(JSON.stringify(payload))
    },
    selectedLuTemplateDocumentOriginal(state, payload) {
      state.selectedLuTemplateDocumentOriginal = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuTemplateDocument(context, payload) {
      context.commit('selectedLuTemplateDocument', payload)
    },
    async loadLuTemplateDocuments(context, payload) {
      const url = 'LuTemplateDocument'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('luTemplateDocuments', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    refreshSelectedLuTemplateDocument(context, payload) {
      if (
        context.state.selectedLuTemplateDocument &&
        context.state.selectedLuTemplateDocument.Id > 0
      ) {
        context.dispatch(
          'loadSelectedLuTemplateDocument',
          context.state.selectedLuTemplateDocument.Id
        )
      }
    },
    async loadSelectedLuTemplateDocument(context, payload) {
      if (
        context.state.selectedLuTemplateDocument &&
        context.state.selectedLuTemplateDocument.Id != payload
      ) {
        context.commit('selectedLuTemplateDocument', {})
      }
      const url = 'LuTemplateDocument/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedLuTemplateDocument', res.data)
        context.commit('selectedLuTemplateDocumentOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    clearLookupCacheAndReloadLuTemplateDocuments(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadLuTemplateDocuments')
      })
    },
    async createLuTemplateDocument(context, payload) {
      const url = `LuTemplateDocument`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'template document created' },
          { root: true }
        )
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuTemplateDocuments')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchLuTemplateDocument(context, payload) {
      var item = context.state.selectedLuTemplateDocument
      if (
        payload.Id &&
        payload.Id == context.state.selectedLuTemplateDocumentOriginal.Id
      ) {
        item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedLuTemplateDocumentOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(original, current)
        patchPayload.patchDoc = diff
      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `LuTemplateDocument/${patchPayload.Id}`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios.patch(url, patchPayload.patchDoc)
          context.dispatch(
            'messages/toastMessage',
            { color: 'success', message: 'template document updated' },
            { root: true }
          )
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadLuTemplateDocuments')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateLuTemplateDocument(context, payload) {
      const url = `LuTemplateDocument/${payload.Id}`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.put(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'template document updated' },
          { root: true }
        )
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuTemplateDocuments')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveLuTemplateDocument(context, payload) {
      if (payload.Id > 0) {
        return context.dispatch('updateLuTemplateDocument', payload)
      } else {
        return context.dispatch('createLuTemplateDocument', payload)
      }
    },
    async deleteLuTemplateDocument(context, payload) {
      const url = `LuTemplateDocument/${payload.Id}`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'template document deleted' },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuTemplateDocuments')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default luTemplateDocument
